import { render, staticRenderFns } from "./Hostvalidate.vue?vue&type=template&id=38a8129b"
import script from "./Hostvalidate.vue?vue&type=script&lang=js"
export * from "./Hostvalidate.vue?vue&type=script&lang=js"
import style0 from "./Hostvalidate.vue?vue&type=style&index=0&id=38a8129b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports